import {filter, set} from 'lodash'
import {useEffect, useState, useRef} from 'react'
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Backdrop,
  Fade,
  Box,
  Grid,
  FormControl,
  TextField,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  LoadingButton,
  useMediaQuery,
  useTheme,
  CardContent,
  CardActions,
  Select,
  InputLabel,
  Autocomplete,
  CircularProgress,
  TableHead,
  FormControlLabel,
} from '@material-ui/core'

// icon
import {Icon} from '@iconify/react'
import closeIcon from '@iconify/icons-eva/close-circle-outline'

// components
import archiveOutline from '@iconify/icons-eva/archive-outline'
import verifiedIcon from '@iconify/icons-eva/checkmark-circle-2-outline'
import viewIcon from '@iconify/icons-eva/eye-outline'
import {Link as RouterLink} from 'react-router-dom'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import Page from '../components/Page'
import Label from '../components/Label'
import Scrollbar from '../components/Scrollbar'
import SearchNotFound from '../components/SearchNotFound'
import {UserListHead, UserListToolbar, UserMoreMenu} from '../components/_dashboard/user'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker'
import LoadingScreen from 'components/LoadingScreen'
import userAPI from 'utils/api/users'
import {logSuccessAction, ACTION_CATEGORIES} from 'utils/actionLogger'
import storage from 'utils/storage'
import Bugsnag from '@bugsnag/js'
import QrReader from 'react-qr-reader'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import {CSVLink} from 'react-csv'
const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
const moment = require('moment-timezone')
moment().tz('Asia/Manila').format()

/**
 * Formats a numeric value with proper decimal places
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - The formatted value as a string
 */
const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined || value === '') {
    return '0.00'
  }
  // Convert to number, handle string inputs
  const num = typeof value === 'string' ? parseFloat(value) : Number(value)
  // Return 0 if not a valid number
  if (isNaN(num)) {
    return '0.00'
  }
  // For hours worked and other metrics, convert negative to 0
  const validNum = num < 0 ? 0 : num
  // Format to specified decimal places and return as string to maintain precision
  return validNum.toFixed(decimals)
}

const TABLE_HEAD = [
  {id: 'generatedBy', label: 'Generated By', alignRight: false},
  {id: 'store', label: 'Store', alignRight: false},
  {id: 'datefrom', label: 'Date From', alignRight: false},
  {id: 'dateto', label: 'Date To', alignRight: false},
  {id: 'employeecount', label: 'Employee Count', alignRight: false},
  {id: 'createdAt', label: 'Created At', alignRight: false},
  {id: 'status', label: 'Status', alignRight: false},
  {id: 'approvedAt', label: 'Approved At', alignRight: false},
  {id: 'approvedby', label: 'Approved By', alignRight: false},
  {id: 'otpSentTo', label: 'OTP Sent To', alignRight: false},
  {id: 'action', label: 'Action', alignRight: false},
  {id: ''},
]

const MODAL_HEAD = [
  {id: 'employeename', label: 'Employee Name', alignRight: false},
  {id: 'dayswork', label: 'Days Work', alignRight: false},
  {id: 'hourswork', label: 'Hours Work', alignRight: false},
  {id: 'hourstardy', label: 'Tardiness (Minutes)', alignRight: false},
  {id: 'overtime', label: 'Overtime', alignRight: false},
  {id: 'nightdiff', label: 'Night Diff', alignRight: false},
  {id: 'restday', label: 'Rest Day (Hours)', alignRight: false},
  {id: 'legalholiday', label: 'Legal Holiday (Hours)', alignRight: false},
  {id: 'specialholiday', label: 'Special Holiday (Hours)', alignRight: false},
]

const SPECIFIC_MODAL_HEAD = [
  {id: 'date', label: 'Date', alignRight: false},
  {id: 'schedule', label: 'Schedule', alignRight: false},
  {id: 'timein', label: 'Time-in', alignRight: false},
  {id: 'timeout', label: 'Time-out', alignRight: false},
  {id: 'workinghours', label: 'Working Hours', alignRight: false},
  {id: 'lates', label: 'Lates (Minutes)', alignRight: false},
  {id: 'ot', label: 'Overtime (Hours)', alignRight: false},
  {id: 'nightdiff', label: 'Night Diff (Hours)', alignRight: false},
  {id: 'rd', label: 'RestDay (Hours)', alignRight: false},
  {id: 'legalholiday', label: 'Legal Holiday (Hours)', alignRight: false},
  {id: 'specialholiday', label: 'Special Holiday (Hours)', alignRight: false},
  {id: 'remarks', label: 'Remarks', alightRight: false},
  {id: ''},
]

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  justifyContent: 'center',
}

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator, query) {
  // Check if the array is valid and not empty
  if (!Array.isArray(array) || array.length === 0) {
    return [] // Return an empty array if input is invalid or empty
  }

  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })

  if (query) {
    return filter(array, (_user) =>
      _user.displayName ? _user.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1 : '',
    )
  }

  return stabilizedThis.map((el) => el[0])
}

function applySortFilterSchedule(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })

  if (query) {
    return filter(array, (_user) => (_user.date ? _user.date : ''))
  }
  return stabilizedThis.map((el) => el[0])
}

export default function User() {
  const ref = useRef(null)
  const getTodayDateOnly = () => {
    const today = new Date()
    return new Date(today.getFullYear(), today.getMonth(), today.getDate())
  }
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [selected, setSelected] = useState([])
  const [orderBy, setOrderBy] = useState('name')
  const [filterName, setFilterName] = useState('')
  const [selectedBreaklist, setSelectedBreaklist] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [specificPageSchedule, setSpecificPageSchedule] = useState(0)
  const [users, setUsers] = useState([])
  const [open, setOpen] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [id, setId] = useState()
  const [name, setName] = useState()
  const [approved, setApproved] = useState()
  const [user, setUser] = useState({})
  const [action, setAction] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [openApproveDialog, setOpenApproveDialog] = useState(false)
  const d = new Date()
  const [date, setDate] = useState(d.setDate(d.getDate() - 1))
  const [fromDate, setFromDate] = useState(dayjs(new Date()).format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(dayjs(new Date()).format('YYYY-MM-DD'))
  const [daysWork, setDaysWork] = useState('')
  const [hoursWork, setHoursWork] = useState('')
  const [hoursTardy, setHoursTardy] = useState(0)
  const [overtime, setOvertime] = useState(0)
  const [nightdiff, setNightdiff] = useState(0)
  const [otp, setOtp] = useState()
  const [specificSchedule, setSpecificSchedule] = useState([])
  const [specificScheduleName, setSpecificScheduleName] = useState('')
  const [breaklistInfo, setBreaklistInfo] = useState([])
  const csvLinkRef = useRef()
  const [resultRequest, setresultRequest] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [submittedBy, setSubmittedBy] = useState('')
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [menuState, setMenuState] = useState({anchorEl: null, openMenuId: null})
  const [company, setCompany] = useState([])
  const [selectedCompany, setSelectedCompany] = useState('')
  const [count, setCount] = useState()
  const [openQR, setOpenQR] = useState(false)
  const [loadingModal, setLoadingModal] = useState(false)
  const [generatedBy, setGeneratedBy] = useState('')
  const [otpCooldown, setOtpCooldown] = useState(60)
  const [isSendingOtp, setIsSendingOtp] = useState(false)
  const [termsAgreed, setTermsAgreed] = useState(false)
  const [approvedBy, setApprovedBy] = useState('')
  const [isApproving, setIsApproving] = useState(false)

  // --- OTP Cool-down Handling --------------------------------------------
  // Duration in seconds for the OTP resend cool-down (1 minute)
  const OTP_COOLDOWN_SECONDS = 60

  // Helper to initialise / restart the cool-down timer and persist it to localStorage
  const startOtpCooldown = (duration = OTP_COOLDOWN_SECONDS) => {
    // Persist the expiry timestamp so that we can restore it after refresh/navigation
    const expiry = Date.now() + duration * 1000
    localStorage.setItem('breaklist_otp_expiry', String(expiry))
    setOtpCooldown(duration)
  }

  // When the component mounts, restore any existing cool-down from localStorage
  useEffect(() => {
    const storedExpiry = localStorage.getItem('breaklist_otp_expiry')
    if (storedExpiry) {
      const remaining = Math.floor((parseInt(storedExpiry, 10) - Date.now()) / 1000)
      if (remaining > 0) {
        setOtpCooldown(remaining)
      } else {
        // Expired – cleanup
        localStorage.removeItem('breaklist_otp_expiry')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const filteredData = (array, order, orderBy) => {
    return array.sort((a, b) => {
      if (orderBy === 'employeename') {
        if (order === 'asc') {
          return a.employeename.localeCompare(b.employeename)
        } else {
          return b.employeename.localeCompare(a.employeename)
        }
      }
      return 0 // Add more sorting logic for other properties if needed
    })
  }

  const handleInputChange = (event) => {
    setSubmittedBy(event.target.value)
  }
  /*const [specificSchedule, setSpecificSchedule] = useState([])*/

  const load = async () => {
    setLoading(true)
    const local_user = await storage.getUser()
    if (!local_user) return

    const user = JSON.parse(local_user)
    setUser(user)

    const fomattedDate = moment(date).format('YYYY-MM-DD')
    if (user.role >= 3) {
      const getCompany = await userAPI.get_group_store(user._id)
      if (getCompany.status === 200) {
        if (getCompany.data.report.store.length > 0) {
          setCompany(getCompany.data.report.store)
          setSelectedCompany(getCompany.data.report.store[0])
          const data = {
            store: getCompany.data.report.store[0],
          }

          const result = await userAPI.get_store_breaklist(data)
          if (result.status === 200) {
            setUsers(result.data.data)
          } else {
            setUsers([])
            alert(result.data.msg)
          }
        } else {
          setUsers([])
          setCompany([])
          setSelectedCompany()
        }
      } else {
        setUsers()
      }
    } else {
      const data = {
        store: user.company,
      }

      const result = await userAPI.get_store_breaklist(data)
      if (result.status === 200) {
        setUsers(result.data.data)
      } else {
        setUsers([])
        alert(result.data.msg)
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    load()
  }, [])

  // Global interval to keep cooldown in sync with persisted expiry time
  useEffect(() => {
    const interval = setInterval(() => {
      const expiryRaw = localStorage.getItem('breaklist_otp_expiry')
      if (!expiryRaw) {
        setOtpCooldown(0)
        return
      }

      const remaining = Math.max(0, Math.floor((parseInt(expiryRaw, 10) - Date.now()) / 1000))
      setOtpCooldown(remaining)

      if (remaining === 0) {
        localStorage.removeItem('breaklist_otp_expiry')
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  // useEffect(() => {
  //   const load = async () => {
  //     const local_user = await storage.getUser()
  //     if (!local_user) return

  //     const user = JSON.parse(local_user)
  //     setUser(user)
  //     const data = {
  //       "from": fromDate,
  //       "to": toDate,
  //       "store": user.company
  //     }
  //     const result = await userAPI.get_breaklist(data)
  //     if(result.status === 200) {
  //       setUsers(result.data.data)
  //       setresultRequest(JSON.parse(result.config.data))
  //       console.log(result.data.data)
  //     }
  //     else {
  //       console.log(result)
  //       setUsers([])
  //       alert(result.data.msg)
  //     }
  //   }

  //   load()
  // }, [action])

  const handleDeleteStore = async () => {
    setLoading(true)
    const data = {
      store: selectedCompany,
      id: user._id,
    }
    const result = await userAPI.delete_group_store(data)
    const getCompany = await userAPI.get_group_store(user._id)
    if (getCompany.status === 200) {
      if (getCompany.data.report.store.length > 0) {
        setCompany(getCompany.data.report.store)
        setSelectedCompany(getCompany.data.report.store[0])
        const data = {
          store: getCompany.data.report.store[0],
        }

        const result = await userAPI.get_store_breaklist(data)
        if (result.status === 200) {
          setUsers(result.data.data)
        } else {
          setUsers([])
          alert(result.data.msg)
        }
      } else {
        setUsers([])
        setCompany([])
        setSelectedCompany()
      }
    } else {
      setUsers()
    }
    setLoading(false)
  }

  const handleEmployeeCellClick = async (id, name) => {
    setLoadingModal(true)
    setSpecificScheduleName(name)
    const fromSpecific = dayjs(fromDate).format('YYYY-MM-DD')
    const toSpecific = dayjs(toDate).format('YYYY-MM-DD')
    const data = {
      id: id,
      from: fromSpecific,
      to: toSpecific,
    }
    try {
      const resultEmployee = await userAPI.get_schedule_with_range(data)
      setSpecificSchedule(resultEmployee.data)
    } catch (error) {
      console.error('Error fetching schedule:', error)
    } finally {
      setLoadingModal(false)
    }
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.generatedby)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }
    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleFilterByName = (event) => {
    setFilterName(event.target.value)
  }

  const handleClose = () => {
    if (loadingModal) {
      if (!filteredEmployeeSchedule) {
        return
      }
    }
    if (filteredEmployeeSchedule) {
      handleCloseSpecificSchedule()
      return
    }
    setOpen(false)
  }

  const handleCloseSpecificSchedule = () => {
    setSpecificSchedule([])
  }

  const handleChangeFromDate = async (date) => {
    const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : null
    setFromDate(dateOnly)
  }

  const handleChangeToDate = async (date) => {
    const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : null
    setToDate(dateOnly)
  }

  function isDateIncluded(date, array) {
    return array.some((item) => item.date === date)
  }

  const handleCellClick = async (breaklistid, approved, fromdate, todate, generatedby) => {
    // let breaklistSummary = []
    setLoading(true)
    handleCloseSpecificSchedule()
    setGeneratedBy(`${generatedby} (${dayjs(fromdate).format('YYYY-MM-DD')} to ${dayjs(todate).format('YYYY-MM-DD')})`)
    setApproved(approved)
    setFromDate(fromdate)
    setToDate(todate)
    const data = {
      breaklistid: breaklistid,
    }
    const result = await userAPI.get_breaklistinfo(data)
    console.log(result)
    setBreaklistInfo(result.data.data)
    /*setSpecificReport(result.data)*/
    setOpen(true)
    setLoading(false)
  }

  /*  const handleBlur = async () => {
      console.log("Success")
    }*/

  const handleGenerateBreaklist = async () => {
    setLoading(true)
    const data = {
      from: fromDate,
      to: toDate,
      store: user.company,
    }
    const result = await userAPI.get_all_breaklist(data)
    if (result.status === 200) {
      setUsers(result.data.data)
    } else {
      setUsers([])
      alert(result.data.msg)
    }
    setLoading(false)
  }

  const handleSubmit = () => {
    setOpenDialog(true)
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName)

  // const filteredSchedule = specificSchedule ? applySortFilter(specificSchedule, getComparator(order, orderBy), filterName) : false;
  const filteredEmployeeSchedule =
    specificSchedule.length > 0 ? applySortFilter(specificSchedule, getComparator(order, orderBy), '') : false

  const isUserNotFound = filteredUsers.length === 0

  // const handleInputChange = (e, id, field) => {
  //   const { value } = e.target;
  //   setInputValues(prevState => ({
  //     ...prevState,
  //     [id]: {
  //       ...prevState[id],
  //       [field]: value
  //     }
  //   }));
  // };

  const handleSaveUpdates = () => {
    console.log('Hellow')
  }

  const handleClickOpen = () => {
    setOpen(true)
    setIsOpen(false)
  }

  const handleDeleteBreaklist = (value, status) => {
    if (status) {
      alert('Unable to delete breaklist already sent to payroll')
    } else {
      setOpenDeleteDialog(true)
      setIsOpen(false)
      setSelected(value)
    }
  }

  const handleMenuOpen = (event, id) => {
    setMenuState({anchorEl: event.currentTarget, openMenuId: id})
  }

  const handleMenuClose = () => {
    setMenuState({anchorEl: null, openMenuId: null})
  }

  const handleConfirmDelete = async () => {
    setLoading(true)

    // Find the breaklist being deleted for logging
    const breaklistToDelete = users.find((u) => u.breaklistid === selected)

    const data = {
      breaklistid: selected,
    }
    const result = await userAPI.delete_breaklist(data)
    if (result.status === 200) {
      // Log successful breaklist deletion
      if (breaklistToDelete) {
        logSuccessAction({
          user: user._id,
          company: breaklistToDelete.store,
          userDisplay: {
            name: user.displayName,
            email: user.email,
          },
          role: user.role,
          action: 'Delete Breaklist',
          category: ACTION_CATEGORIES.BREAKLIST,
          details: `Successfully deleted breaklist generated by ${breaklistToDelete.generatedby} for ${
            breaklistToDelete.store
          } (${moment(breaklistToDelete.datefrom).format('YYYY-MM-DD')} to ${moment(breaklistToDelete.dateto).format(
            'YYYY-MM-DD',
          )}) with ${breaklistToDelete.employeecount} employees. Created: ${moment(breaklistToDelete.createdAt).format(
            'YYYY-MM-DD',
          )}`,
        })
      }

      // setUsers(result.data.data)
    } else {
      setUsers([])
      alert(result.data.msg)
    }
    load()
    setLoading(false)
  }

  const handleConfirmApprove = async () => {
    setIsApproving(true)

    // Find the breaklist being approved for logging
    const breaklistToApprove = users.find((u) => u.breaklistid === selectedBreaklist)

    try {
      const data = {
        id: user._id,
        breaklistid: selectedBreaklist,
        otp: otp,
        approvedBy: approvedBy,
      }
      const result = await userAPI.approve_breaklist(data)
      if (result.data.success) {
        // Log successful breaklist approval
        if (breaklistToApprove) {
          logSuccessAction({
            user: user._id,
            company: breaklistToApprove.store,
            userDisplay: {
              name: user.displayName,
              email: user.email,
            },
            role: user.role,
            action: 'Approve Breaklist',
            category: ACTION_CATEGORIES.BREAKLIST,
            details: `Successfully approved breaklist generated by ${breaklistToApprove.generatedby} for ${
              breaklistToApprove.store
            } (${moment(breaklistToApprove.datefrom).format('YYYY-MM-DD')} to ${moment(
              breaklistToApprove.dateto,
            ).format('YYYY-MM-DD')}) with ${
              breaklistToApprove.employeecount
            } employees. Approved by: ${approvedBy}. OTP sent to: ${
              user.useAlternativeBreaklistEmail && user.alternativeBreaklistEmail
                ? user.alternativeBreaklistEmail
                : user.email
            }`,
          })
        }

        alert('Approve success')
        setOtpCooldown(0) // Reset cooldown after successful approval
        setOtp('')
        setTermsAgreed(false)
        setApprovedBy('')
        setOpenApproveDialog(false) // Close dialog on success
        await load() // Reload the data
      } else {
        alert(result.data.message || 'Approval failed')
        // Dialog remains open on failure
      }
    } catch (error) {
      console.error('Error approving breaklist:', error)
      alert('An error occurred while approving the breaklist. Please try again.')
      // Dialog remains open on error
    } finally {
      setIsApproving(false)
    }
  }

  const labelDisplayedRows = ({from, to, count}) => {
    return `${from}-${to} of ${count}`
  }

  const handleApproveBreaklist = async (value) => {
    setLoading(true)
    await handleResendOtp()
    await setOpenApproveDialog(true)
    await setIsOpen(false)
    await setSelectedBreaklist(value)
    setLoading(false)
  }

  const handleResendOtp = async () => {
    if (otpCooldown > 0 || isSendingOtp) return

    setIsSendingOtp(true)
    try {
      startOtpCooldown()
      const resendOtpData = {id: user._id, breaklist: true}
      await userAPI.approve_breaklist_otp(resendOtpData)
      alert('OTP sent successfully!')
    } catch (error) {
      console.error('Error resending OTP:', error)
      alert('Failed to send OTP. Please try again.')
      setOtpCooldown(0)
    } finally {
      setIsSendingOtp(false)
    }
  }

  const handleStoreChange = async (value) => {
    if (value === selectedCompany || value === null) return
    setLoading(true)
    const fomattedDate = moment(date).format('YYYY-MM-DD')
    setSelectedCompany(value)
    const data = {
      store: value,
    }

    const result = await userAPI.get_store_breaklist(data)
    if (result.status === 200) {
      setUsers(result.data.data)
    }
    setLoading(false)
  }

  const handleOpenQRModal = async () => {
    setOpenQR(true)
  }

  const handleCloseQR = () => {
    setOpenQR(false)
  }

  const handleError = (err) => {
    alert(err)
  }

  const handleScan = async (res) => {
    const url = new URL(res)
    const pathSegments = url.pathname.split('/')
    const id = pathSegments[1]
    const data = {
      uid: user._id,
      storeid: id,
    }
    if (res) {
      const result = await userAPI.post_group_store(data)
      if (result.status === 200) {
        load()
        setOpenQR(false)
        alert('Success')
      } else {
        alert('Something went wrong please try again later!')
      }
    } else {
      alert('No link found in the response.')
    }
  }

  const getCsvData = () => {
    const csvData = []
    csvData.push([`Company: `, `${selectedCompany}`])
    csvData.push([`Date: `, `${formatDate(fromDate)} to ${formatDate(toDate)}`])
    csvData.push(['', '', '', '', '', ''])
    csvData.push(['', '', '', '', '', ''])
    csvData.push([
      'Employee',
      'Days Work',
      'Hours Work',
      'Tardiness( Minutes )',
      'Overtime( Hours )',
      'Night Diff( Hours )',
      'RD Work( Hours )',
      'Legal Holiday ( Hours )',
      'Special Holiday ( Hours )',
    ])
    if (breaklistInfo) {
      breaklistInfo.map((data) => {
        if (data.specialholiday <= 0) {
          data.specialholiday = 0
        }
        csvData.push([
          data.employeename,
          data.dayswork,
          data.hourswork,
          data.hourstardy,
          data.overtime,
          data.nightdiff,
          data.restday,
          data.legalholiday,
          data.specialholiday,
        ])
      })
    }

    return csvData
  }

  const handleExportBreaklist = async () => {
    csvLinkRef.current.link.click()
  }

  const formatDate = (isoString) => {
    const date = new Date(isoString)
    return date.toLocaleDateString('en-CA') // 'en-CA' ensures YYYY-MM-DD format
  }

  return (
    <Page title="Breaklist | Time In">
      <Container maxWidth="xl">
        {isMobile ? (
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {user && user.role >= 3 && (
                  <FormControl sx={{mt: 4, ml: 3, width: '95%'}}>
                    <Box display="flex" alignItems="center">
                      <Autocomplete
                        id="store-select"
                        value={selectedCompany === null ? company[0] : selectedCompany}
                        onChange={(event, value) => handleStoreChange(value)}
                        options={company}
                        placeholder="Store"
                        renderInput={(params) => <TextField {...params} label="Store" />}
                        sx={{
                          flexGrow: 1,
                          whiteSpace: 'nowrap',
                          overflow: 'auto',
                          textOverflow: 'ellipsis',
                          pt: 1,
                        }}
                      />
                      <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ml: 0.5}}>
                        <AddIcon />
                      </IconButton>
                      <IconButton color="primary" aria-label="delete store" onClick={handleDeleteStore} sx={{ml: 0.5}}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />
              </Grid>
            </Grid>
            <Typography variant="h6" gutterBottom sx={{mt: 3, textAlign: 'center'}}>
              {filteredUsers.length} Records found
            </Typography>
            <Scrollbar>
              {users ? (
                <Grid container spacing={2}>
                  {filteredUsers
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const {
                        _id,
                        generatedby,
                        store,
                        datefrom,
                        dateto,
                        employeecount,
                        createdAt,
                        breaklistid,
                        approved,
                        updatedAt,
                        approvedby,
                        otpSentTo,
                      } = row
                      const isItemSelected = selected.indexOf(generatedby) !== -1
                      const isMenuOpen = menuState.openMenuId === _id

                      return (
                        <Grid item xs={12} key={_id}>
                          <Card
                            sx={{
                              boxShadow: 2,
                              borderRadius: 2,
                              bgcolor: 'background.paper',
                              mb: 2,
                              '&:hover': {
                                boxShadow: 5,
                              },
                            }}
                          >
                            <CardContent sx={{pb: 1}}>
                              <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                  <Avatar alt={generatedby} sx={{width: 28, height: 28}} />
                                  <Typography variant="h6" sx={{fontWeight: 'bold', fontSize: '1rem'}}>
                                    {generatedby}
                                  </Typography>
                                </Stack>
                                <Box
                                  sx={{
                                    bgcolor: approved ? 'success.light' : 'warning.light',
                                    color: approved ? 'success.dark' : 'warning.dark',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 1,
                                    fontSize: '0.75rem',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {approved ? 'Approved' : 'Pending'}
                                </Box>
                              </Box>

                              <Grid container spacing={1} sx={{mt: 1}}>
                                <Grid item xs={6}>
                                  <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                    Store:
                                  </Typography>
                                  <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                    {store}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                    Employee Count:
                                  </Typography>
                                  <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                    {employeecount}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                    Date From:
                                  </Typography>
                                  <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                    {moment(datefrom).format('YYYY-MM-DD')}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                    Date To:
                                  </Typography>
                                  <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                    {moment(dateto).format('YYYY-MM-DD')}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                    Created At:
                                  </Typography>
                                  <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                    {moment(createdAt).format('YYYY-MM-DD')}
                                  </Typography>
                                </Grid>
                                {approved && (
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                      Approved At:
                                    </Typography>
                                    <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                      {moment(updatedAt).format('YYYY-MM-DD')}
                                    </Typography>
                                  </Grid>
                                )}
                                {approved && approvedby && (
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                      Approved By:
                                    </Typography>
                                    <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                      {approvedby}
                                    </Typography>
                                  </Grid>
                                )}
                                {approved && otpSentTo && (
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.75rem'}}>
                                      OTP Sent To:
                                    </Typography>
                                    <Typography variant="body1" sx={{fontSize: '0.85rem'}}>
                                      {otpSentTo}
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>
                            </CardContent>
                            <CardActions sx={{pt: 0, pb: 1, justifyContent: 'space-around'}}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  handleCellClick(breaklistid, approved, datefrom, dateto, generatedby)
                                }}
                                startIcon={<Icon icon={viewIcon} width={18} height={18} />}
                                sx={{flexGrow: 1, mr: 1, ml: 1}}
                              >
                                View
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                color="error"
                                onClick={() => {
                                  handleDeleteBreaklist(breaklistid, approved)
                                }}
                                startIcon={<Icon icon={archiveOutline} width={18} height={18} />}
                                sx={{flexGrow: 1, mr: 1}}
                                disabled={approved}
                              >
                                Delete
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                color="success"
                                onClick={() => {
                                  handleApproveBreaklist(breaklistid)
                                }}
                                startIcon={<Icon icon={verifiedIcon} width={18} height={18} />}
                                sx={{flexGrow: 1, mr: 1}}
                                disabled={approved || isLoading}
                              >
                                Approve
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                      )
                    })}

                  {filteredUsers.length === 0 && (
                    <Grid item xs={12}>
                      <Typography align="center">No users found</Typography>
                    </Grid>
                  )}
                </Grid>
              ) : (
                <Typography>No data found</Typography>
              )}
            </Scrollbar>
          </Box>
        ) : (
          <>
            {isLoading ? (
              <Box sx={{height: '50vh'}}>
                <LoadingScreen />
              </Box>
            ) : (
              <Card>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={5}>
                    {user && user.role >= 3 && (
                      <FormControl sx={{mt: 2, ml: 3, width: '85%'}}>
                        <Box display="flex" alignItems="center">
                          <Autocomplete
                            id="store-select"
                            value={selectedCompany === null ? company[0] : selectedCompany}
                            onChange={(event, value) => handleStoreChange(value)}
                            options={company}
                            placeholder="Store"
                            renderInput={(params) => <TextField {...params} label="Store" />}
                            sx={{
                              flexGrow: 1,
                              whiteSpace: 'nowrap',
                              overflow: 'auto',
                              textOverflow: 'ellipsis',
                              pt: 1,
                            }}
                          />
                          <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ml: 1}}>
                            <AddIcon />
                          </IconButton>
                          <IconButton
                            color="primary"
                            aria-label="delete store"
                            onClick={handleDeleteStore}
                            sx={{ml: 1}}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
                    <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />
                  </Grid>
                  <Grid item xs={3} md={3}>
                    {/* <FormControl sx={{ mt: 4, width: "75%" }}>
                    <Button
                      variant="contained"
                      to="#"
                      onClick={handleGenerateBreaklist}
                    >
                      Generate
                    </Button>
                  </FormControl> */}
                  </Grid>
                  <Grid item xs={3} md={3}>
                    {/* <FormControl sx={{ mt: 4, width: "75%" }}>
                    <Button
                      variant="contained"
                      to="#"
                      onClick={handleGenerateBreaklist}
                    >
                      Generate
                    </Button>
                  </FormControl> */}
                  </Grid>
                </Grid>
                <Scrollbar>
                  <TableContainer sx={{minWidth: 800}}>
                    {users ? (
                      <Table>
                        <TableHead>
                          <UserListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={users ? users.length : 0}
                            numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                            onSelectAllClick={handleSelectAllClick}
                          />
                        </TableHead>
                        <TableBody>
                          {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            const {
                              _id,
                              generatedby,
                              store,
                              datefrom,
                              dateto,
                              employeecount,
                              createdAt,
                              breaklistid,
                              approved,
                              updatedAt,
                              approvedby,
                              otpSentTo,
                            } = row
                            //   let formattedHoursWork = !isNaN(hourswork) && hourswork !== null && hourswork !== undefined
                            //     ? parseFloat(hourswork).toFixed(2)
                            //     : '0.00';
                            //   let formattedHoursTardy = !isNaN(hourstardy) && hourstardy !== null && hourstardy !== undefined
                            //     ? parseFloat(hourstardy).toFixed(2)
                            //     : '0.00';
                            //   let formattedOvertime = !isNaN(overtime) && overtime !== null && overtime !== undefined
                            //     ? parseFloat(overtime).toFixed(2)
                            //     : '0.00';
                            //   let formattedNightdiff =  !isNaN(nightdiff) && nightdiff !== null && nightdiff !== undefined
                            //     ? parseFloat(nightdiff).toFixed(2)
                            //     : '0.00';

                            const isItemSelected = selected.indexOf(generatedby) !== -1
                            const isMenuOpen = menuState.openMenuId === _id

                            return (
                              <TableRow
                                hover
                                key={_id}
                                tabIndex={-1}
                                role="checkbox"
                                selected={isItemSelected}
                                aria-checked={isItemSelected}
                                sx={{
                                  ...(row.remarks &&
                                    row.remarks.toString().trim() !== '' &&
                                    row.remarks.toString() !== 'no remarks' && {
                                      backgroundColor: '#ffebee',
                                      '&:hover': {
                                        backgroundColor: '#ffcdd2',
                                      },
                                    }),
                                }}
                              >
                                {/*<TableCell padding="checkbox">
                                <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                              </TableCell>*/}
                                <TableCell
                                  component="th"
                                  scope="row"
                                  padding="none"
                                  onClick={() => handleCellClick(breaklistid, approved, datefrom, dateto, generatedby)}
                                  sx={{
                                    fontWeight: 'bold',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      color: 'primary.main',
                                    },
                                  }}
                                >
                                  <Stack direction="row" alignItems="center" spacing={2}>
                                    <Avatar sx={{ml: 2}} alt={generatedby} className="ml-3" />
                                    <Typography variant="subtitle2" noWrap>
                                      {generatedby}
                                    </Typography>
                                  </Stack>
                                </TableCell>
                                <TableCell align="left">{store}</TableCell>
                                <TableCell align="left">{moment(datefrom).format('YYYY-MM-DD')}</TableCell>
                                <TableCell align="left">{moment(dateto).format('YYYY-MM-DD')}</TableCell>
                                <TableCell align="center">{employeecount}</TableCell>
                                <TableCell align="left">{moment(createdAt).format('YYYY-MM-DD')}</TableCell>
                                <TableCell align="left" style={{color: approved ? 'green' : 'red'}}>
                                  {approved ? 'Approved' : 'Pending'}
                                </TableCell>
                                <TableCell align="left">
                                  {approved ? moment(updatedAt).format('YYYY-MM-DD hh:mm A') : '-'}
                                </TableCell>
                                <TableCell align="left">{approvedby || '-'}</TableCell>
                                <TableCell align="left">{otpSentTo || '-'}</TableCell>
                                <TableCell align="left">
                                  {/* <IconButton ref={ref} onClick={() => setIsOpen(true)}> */}
                                  <IconButton onClick={(event) => handleMenuOpen(event, _id)}>
                                    <Icon icon={moreVerticalFill} width={20} height={20} />
                                  </IconButton>
                                  <Menu
                                    open={isMenuOpen}
                                    anchorEl={menuState.anchorEl}
                                    onClose={() => handleMenuClose()}
                                    PaperProps={{
                                      sx: {width: 200, maxWidth: '100%'},
                                    }}
                                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                                    transformOrigin={{vertical: 'top', horizontal: 'right'}}
                                  >
                                    <MenuItem component={RouterLink} to="#" sx={{color: 'text.secondary'}}>
                                      <ListItemIcon>
                                        <Icon icon={viewIcon} width={24} height={24} style={{color: 'blue'}} />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="View"
                                        onClick={() => {
                                          handleCellClick(breaklistid, approved, datefrom, dateto, generatedby)
                                          handleMenuClose()
                                        }}
                                        primaryTypographyProps={{variant: 'body2', style: {color: 'blue'}}}
                                      />
                                    </MenuItem>
                                    <MenuItem component={RouterLink} to="#" sx={{color: 'text.secondary'}}>
                                      <ListItemIcon>
                                        <Icon icon={archiveOutline} width={24} height={24} style={{color: 'red'}} />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Delete"
                                        onClick={() => {
                                          handleDeleteBreaklist(breaklistid, approved)
                                          handleMenuClose()
                                        }}
                                        primaryTypographyProps={{variant: 'body2', style: {color: 'red'}}}
                                      />
                                    </MenuItem>
                                    <MenuItem component={RouterLink} to="#" sx={{color: 'text.secondary'}}>
                                      <ListItemIcon>
                                        <Icon icon={verifiedIcon} width={24} height={24} style={{color: 'green'}} />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Approve"
                                        disabled={isLoading}
                                        onClick={() => {
                                          handleApproveBreaklist(breaklistid)
                                          handleMenuClose()
                                        }}
                                        primaryTypographyProps={{variant: 'body2', style: {color: 'green'}}}
                                      />
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                          {emptyRows > 0 && (
                            <TableRow style={{height: 53 * emptyRows}}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        {isUserNotFound && (
                          <TableBody>
                            <TableRow>
                              <TableCell align="center" colSpan={8} sx={{py: 3}}>
                                <SearchNotFound searchQuery={filterName} />
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )}
                      </Table>
                    ) : (
                      ''
                    )}
                  </TableContainer>
                </Scrollbar>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={users ? users.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={'Rows per page'}
                  labelDisplayedRows={labelDisplayedRows}
                />
              </Card>
            )}
          </>
        )}

        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box
              sx={style}
              style={{
                width: isMobile ? '95%' : '70%',
                position: 'relative',
                maxHeight: '90vh',
                overflow: 'auto',
              }}
            >
              {filteredEmployeeSchedule ? (
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <Typography variant="h4" gutterBottom sx={{textAlign: 'center'}}>
                    {`${specificScheduleName} (Record)`}
                  </Typography>
                  <Button sx={{position: 'absolute', right: 1, top: 12, zIndex: 10}} onClick={handleClose}>
                    <Icon icon={closeIcon} width={25} height={25} color="#b2b2b2" />
                  </Button>
                </Box>
              ) : (
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <Typography variant="h4" gutterBottom sx={{textAlign: 'center'}}>
                    {generatedBy}
                  </Typography>
                  <Button sx={{position: 'absolute', right: 1, top: 12, zIndex: 10}} onClick={handleClose}>
                    <Icon icon={closeIcon} width={25} height={25} color="#b2b2b2" />
                  </Button>
                </Box>
              )}
              {isMobile ? (
                <Box sx={{mt: 4}}>
                  <Typography variant="h6" gutterBottom sx={{textAlign: 'center'}}>
                    {filteredEmployeeSchedule
                      ? filteredEmployeeSchedule.length
                      : filteredData(breaklistInfo, order, orderBy).length}{' '}
                    Records found
                  </Typography>

                  {filteredEmployeeSchedule ? (
                    <Grid container spacing={2} sx={{maxHeight: '70vh', overflowY: 'auto', pb: 2}}>
                      {filteredEmployeeSchedule.map((row, index) => {
                        const {
                          _id,
                          name,
                          date,
                          from,
                          to,
                          timeIn,
                          timeOut,
                          hoursTardy,
                          overtime,
                          nightdiff,
                          hourswork,
                          rd,
                          legalholiday,
                          specialholiday,
                          remarks,
                        } = row

                        const formattedDate = moment(date).format('YYYY-MM-DD')

                        return (
                          <Grid item xs={12} key={`${_id}-${index}`}>
                            <Card
                              sx={{
                                boxShadow: 2,
                                borderRadius: 2,
                                bgcolor: 'background.paper',
                                '&:hover': {
                                  boxShadow: 5,
                                },
                              }}
                            >
                              <CardContent>
                                <Typography variant="h6" gutterBottom>
                                  {formattedDate}
                                </Typography>

                                <Grid container spacing={2}>
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Schedule:
                                    </Typography>
                                    <Typography variant="body1">
                                      {from} to {to}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Time In:
                                    </Typography>
                                    <Typography variant="body1">{timeIn || '-'}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Time Out:
                                    </Typography>
                                    <Typography variant="body1">{timeOut || '-'}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Hours Worked:
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        color:
                                          !hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0
                                            ? 'red'
                                            : 'inherit',
                                      }}
                                    >
                                      {!timeIn &&
                                      !timeOut &&
                                      (!hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0)
                                        ? 'Absent'
                                        : !hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0
                                        ? '0.00'
                                        : formatNumber(hourswork)}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Tardiness (Minutes):
                                    </Typography>
                                    <Typography variant="body1" sx={{color: hoursTardy > 0 ? 'red' : 'inherit'}}>
                                      {formatNumber(hoursTardy || 0)}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Overtime (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(overtime || 0)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Night Diff (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(nightdiff || 0)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Rest Day (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(rd || 0)}</Typography>
                                  </Grid>

                                  {remarks && (
                                    <Grid item xs={12}>
                                      <Typography variant="body2" color="text.secondary">
                                        Remarks:
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          backgroundColor: '#f5f5f5',
                                          p: 1,
                                          borderRadius: 1,
                                          mt: 0.5,
                                        }}
                                      >
                                        {remarks || 'No remarks'}
                                      </Typography>
                                    </Grid>
                                  )}
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        )
                      })}

                      {filteredEmployeeSchedule && filteredEmployeeSchedule.length === 0 && (
                        <Grid item xs={12}>
                          <Typography align="center">No records found</Typography>
                        </Grid>
                      )}

                      {filteredEmployeeSchedule && filteredEmployeeSchedule.length > 0 && (
                        <Grid item xs={12} sx={{mt: 2}}>
                          <Button variant="contained" color="primary" fullWidth onClick={handleCloseSpecificSchedule}>
                            Back to Breaklist
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  ) : (
                    <Grid container spacing={2} sx={{maxHeight: '70vh', overflowY: 'auto', pb: 2}}>
                      {filteredData(breaklistInfo, order, orderBy).map((row, index) => {
                        const {
                          _id,
                          employeename,
                          employeeid,
                          dayswork,
                          hourswork,
                          hourstardy,
                          overtime,
                          nightdiff,
                          restday,
                          legalholiday,
                          specialholiday,
                        } = row

                        return (
                          <Grid item xs={12} key={`${_id}-${index}`}>
                            <Card
                              sx={{
                                boxShadow: 2,
                                borderRadius: 2,
                                bgcolor: 'background.paper',
                                '&:hover': {
                                  boxShadow: 5,
                                },
                              }}
                            >
                              <CardContent>
                                <Box
                                  sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}
                                >
                                  <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                                    {employeename}
                                  </Typography>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleEmployeeCellClick(employeeid, employeename)}
                                  >
                                    View Details
                                  </Button>
                                </Box>

                                <Grid container spacing={2}>
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Days Worked:
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(dayswork, 1)}</Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Hours Worked:
                                    </Typography>
                                    <Typography variant="body1">
                                      {formatNumber(hourswork < 0 ? 0 : hourswork)}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Tardiness (Minutes):
                                    </Typography>
                                    <Typography variant="body1" sx={{color: hourstardy > 0 ? 'red' : 'inherit'}}>
                                      {formatNumber(hourstardy)}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Overtime (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(overtime)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Night Diff (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(nightdiff)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Rest Day (Hours):
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(restday)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Legal Holiday:
                                    </Typography>
                                    <Typography variant="body1">{formatNumber(legalholiday)}</Typography>
                                  </Grid>

                                  <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">
                                      Special Holiday:
                                    </Typography>
                                    <Typography variant="body1">
                                      {formatNumber(specialholiday <= 0 ? 0 : specialholiday)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        )
                      })}

                      {breaklistInfo.length === 0 && (
                        <Grid item xs={12}>
                          <Typography align="center">No data found</Typography>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </Box>
              ) : (
                <TableContainer sx={{minWidth: 700, maxHeight: 500, mt: 4}}>
                  {loadingModal && (
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                      <CircularProgress />
                    </Box>
                  )}
                  {breaklistInfo && !loadingModal ? (
                    <Table stickyHeader>
                      <UserListHead
                        order={order}
                        orderBy={orderBy}
                        headLabel={filteredEmployeeSchedule ? SPECIFIC_MODAL_HEAD : MODAL_HEAD}
                        rowCount={breaklistInfo.length}
                        numSelected={selected.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAllClick}
                      />
                      <TableBody>
                        {filteredEmployeeSchedule ? (
                          <>
                            {filteredEmployeeSchedule.map((row, index) => {
                              const {
                                _id,
                                name,
                                date,
                                from,
                                to,
                                timeIn,
                                timeOut,
                                hoursTardy,
                                overtime,
                                nightdiff,
                                hourswork,
                                rd,
                                legalholiday,
                                specialholiday,
                                remarks,
                              } = row
                              const formattedDate = moment(date).format('YYYY-MM-DD')
                              const isItemSelected = selected.indexOf(name) !== -1
                              console.log(row)
                              return (
                                <TableRow
                                  hover
                                  key={`${_id}-${index}`}
                                  tabIndex={-1}
                                  role="checkbox"
                                  selected={isItemSelected}
                                  aria-checked={isItemSelected}
                                  sx={{
                                    ...(row.remarks &&
                                      row.remarks.toString().trim() !== '' &&
                                      row.remarks.toString() !== 'no remarks' && {
                                        backgroundColor: '#ffebee',
                                        '&:hover': {
                                          backgroundColor: '#ffcdd2',
                                        },
                                      }),
                                  }}
                                >
                                  <TableCell component="th" scope="row" padding="none">
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                      <Typography variant="subtitle2" noWrap sx={{ml: 2}}>
                                        {formattedDate}
                                      </Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell align="left">
                                    {from} to {to}
                                  </TableCell>
                                  <TableCell align="left">{timeIn}</TableCell>
                                  <TableCell align="left">{timeOut}</TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      color:
                                        !hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0
                                          ? 'red'
                                          : 'inherit',
                                    }}
                                  >
                                    {!timeIn &&
                                    !timeOut &&
                                    (!hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0)
                                      ? 'Absent'
                                      : !hourswork || isNaN(Number(hourswork)) || Number(hourswork) <= 0
                                      ? '0.00'
                                      : Number(hourswork).toFixed(1)}
                                  </TableCell>
                                  <TableCell align="left" style={{color: hoursTardy > 0 ? 'red' : 'inherit'}}>
                                    {hoursTardy && !isNaN(Number(hoursTardy)) ? Number(hoursTardy) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {overtime && !isNaN(Number(overtime)) ? Number(overtime) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {nightdiff && !isNaN(Number(nightdiff)) ? Number(nightdiff) : 0}
                                  </TableCell>
                                  <TableCell align="left">{rd && !isNaN(Number(rd)) ? Number(rd) : 0}</TableCell>
                                  <TableCell align="left">
                                    {legalholiday && !isNaN(Number(legalholiday)) ? Number(legalholiday) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {specialholiday && !isNaN(Number(specialholiday))
                                      ? Number(specialholiday) <= 0
                                        ? 0
                                        : Number(specialholiday)
                                      : 0}
                                  </TableCell>
                                  <TableCell align="left">{remarks}</TableCell>
                                </TableRow>
                              )
                            })}
                            {!filteredEmployeeSchedule && (
                              <TableRow style={{height: 53 * emptyRows}}>
                                <TableCell colSpan={6}></TableCell>
                              </TableRow>
                            )}
                            <TableRow style={{backgroundColor: '#e0e0e0'}}>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                Total
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule
                                  .reduce(
                                    (prev, curr) =>
                                      prev +
                                      (curr && curr.hourswork && !isNaN(Number(curr.hourswork))
                                        ? Math.max(0, Number(curr.hourswork))
                                        : 0),
                                    0,
                                  )
                                  .toFixed(1)}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.hoursTardy && !isNaN(Number(curr.hoursTardy))
                                      ? Number(curr.hoursTardy)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.overtime && !isNaN(Number(curr.overtime))
                                      ? Number(curr.overtime)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.nightdiff && !isNaN(Number(curr.nightdiff))
                                      ? Number(curr.nightdiff)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev + (curr && curr.rd && !isNaN(Number(curr.rd)) ? Number(curr.rd) : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.legalholiday && !isNaN(Number(curr.legalholiday))
                                      ? Number(curr.legalholiday)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {filteredEmployeeSchedule.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.specialholiday && !isNaN(Number(curr.specialholiday))
                                      ? Number(curr.specialholiday)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          <>
                            {filteredData(breaklistInfo, order, orderBy).map((row, index) => {
                              const {
                                _id,
                                employeename,
                                employeeid,
                                dayswork,
                                hourswork,
                                hourstardy,
                                overtime,
                                nightdiff,
                                restday,
                                legalholiday,
                                specialholiday,
                                hasRemark,
                              } = row
                              // const formattedDate = moment(date).utc().format('YYYY-MM-DD');
                              const isItemSelected = selected.indexOf(name) !== -1
                              // const rowInputValues = inputValues[_id] || {
                              //   hoursTardy: hoursTardy,
                              //   overtime: overtime,
                              //   nightdiff: nightdiff,
                              // };
                              return (
                                <TableRow
                                  hover
                                  key={`${_id}-${index}`}
                                  tabIndex={-1}
                                  role="checkbox"
                                  selected={isItemSelected}
                                  aria-checked={isItemSelected}
                                  onClick={() => handleEmployeeCellClick(employeeid, employeename)}
                                  sx={{
                                    cursor: 'pointer',
                                    ...(hasRemark && {
                                      backgroundColor: '#ffebee',
                                      '&:hover': {
                                        backgroundColor: '#ffcdd2',
                                      },
                                    }),
                                  }}
                                >
                                  {/*<TableCell padding="checkbox">
                <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
              </TableCell>*/}
                                  <TableCell component="th" scope="row" padding="none">
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                      <Typography
                                        variant="subtitle2"
                                        noWrap
                                        sx={{
                                          ml: 2,
                                          fontWeight: 'bold',
                                          textDecoration: 'underline',
                                          cursor: 'pointer',
                                          '&:hover': {
                                            color: 'primary.main',
                                          },
                                        }}
                                      >
                                        {employeename}
                                      </Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell align="left">
                                    {dayswork && !isNaN(Number(dayswork)) ? Number(dayswork) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {hourswork && !isNaN(Number(hourswork))
                                      ? Number(hourswork) < 0
                                        ? 0
                                        : Number(hourswork).toFixed(1)
                                      : 0}
                                  </TableCell>
                                  <TableCell align="left" style={{color: hourstardy > 0 ? 'red' : 'inherit'}}>
                                    {hourstardy && !isNaN(Number(hourstardy)) ? Number(hourstardy) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {overtime && !isNaN(Number(overtime)) ? Number(overtime) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {nightdiff && !isNaN(Number(nightdiff)) ? Number(nightdiff) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {restday && !isNaN(Number(restday)) ? Number(restday) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {legalholiday && !isNaN(Number(legalholiday)) ? Number(legalholiday) : 0}
                                  </TableCell>
                                  <TableCell align="left">
                                    {specialholiday && !isNaN(Number(specialholiday))
                                      ? Number(specialholiday) <= 0
                                        ? 0
                                        : Number(specialholiday)
                                      : 0}
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                            {emptyRows > 0 && (
                              <TableRow style={{height: 53 * emptyRows}}>
                                <TableCell colSpan={6}> No Data Found </TableCell>
                              </TableRow>
                            )}
                            <TableRow style={{backgroundColor: '#e0e0e0'}}>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                Total
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo
                                  .reduce(
                                    (prev, curr) =>
                                      prev +
                                      (curr && curr.dayswork && !isNaN(Number(curr.dayswork))
                                        ? Math.max(0, Number(curr.dayswork))
                                        : 0),
                                    0,
                                  )
                                  .toFixed(1)}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo
                                  .reduce(
                                    (prev, curr) =>
                                      prev +
                                      (curr && curr.hourswork && !isNaN(Number(curr.hourswork))
                                        ? Math.max(0, Number(curr.hourswork))
                                        : 0),
                                    0,
                                  )
                                  .toFixed(1)}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.hourstardy && !isNaN(Number(curr.hourstardy))
                                      ? Number(curr.hourstardy)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.overtime && !isNaN(Number(curr.overtime))
                                      ? Number(curr.overtime)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.nightdiff && !isNaN(Number(curr.nightdiff))
                                      ? Number(curr.nightdiff)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.restday && !isNaN(Number(curr.restday)) ? Number(curr.restday) : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.legalholiday && !isNaN(Number(curr.legalholiday))
                                      ? Number(curr.legalholiday)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {breaklistInfo.reduce(
                                  (prev, curr) =>
                                    prev +
                                    (curr && curr.specialholiday && !isNaN(Number(curr.specialholiday))
                                      ? Number(curr.specialholiday)
                                      : 0),
                                  0,
                                )}
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableBody>
                      {isUserNotFound && filterName !== '' && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={8} sx={{py: 3}}>
                              <SearchNotFound searchQuery={filterName} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  ) : (
                    !breaklistInfo && !loadingModal && 'No data found'
                  )}
                </TableContainer>
              )}
              {approved ? (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => (filteredEmployeeSchedule ? handleCloseSpecificSchedule() : handleExportBreaklist())}
                  sx={{mt: 2, px: 17}}
                >
                  {filteredEmployeeSchedule ? 'Back' : 'Export'}
                </Button>
              ) : (
                ''
              )}
            </Box>
          </Fade>
        </Modal>
        <CSVLink
          ref={csvLinkRef}
          filename={`Breaklist summary for ${selectedCompany} - ${formatDate(fromDate)} to ${formatDate(toDate)}.csv`}
          data={getCsvData()}
          style={{display: 'none'}} // Hide the CSVLink button
        />
        <Dialog open={openDeleteDialog}>
          <Button sx={{ml: 'auto', pt: 2}} onClick={() => setOpenDeleteDialog(false)}>
            <Icon icon={closeIcon} width={32} height={32} color="#b2b2b2" />
          </Button>
          <DialogTitle sx={{textAlign: 'center'}}>
            <Typography variant="h4" sx={{maxWidth: '75%', mx: 'auto'}}>
              Are you sure to delete Breaklist?
            </Typography>
          </DialogTitle>
          <DialogActions sx={{display: 'block', pb: 5, px: 3}}>
            <Typography variant="h6" sx={{mb: 6, fontWeight: 400, textAlign: 'center', mx: 'auto'}}>
              Once action processed you may not be able to retrieve the data.
            </Typography>
            <Stack sx={{my: 2}}>
              <Button
                color="error"
                size="large"
                variant="contained"
                onClick={() => {
                  // setEdit(true)
                  setOpenDeleteDialog(false)
                  handleConfirmDelete()
                }}
                disabled={false}
                sx={{textTransform: 'initial !important'}}
              >
                Delete
              </Button>
              <Button
                onClick={() => {
                  setOpenDeleteDialog(false)
                  setSelected([])
                }}
                size="large"
                variant="outlined"
                color="error"
                sx={{mt: 2}}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
        <Dialog open={openApproveDialog} maxWidth="sm" fullWidth onClose={() => setOpenApproveDialog(false)}>
          <DialogTitle sx={{textAlign: 'center', pt: 2, pb: 1}}>
            <Typography variant="h5" component="div" sx={{fontWeight: 'bold'}}>
              Do you confirm to approve this breaklist for payroll processing?
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenApproveDialog(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <Icon icon={closeIcon} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{my: 2}}>
              <Typography variant="body1" sx={{mb: 2}}>
                Please review all employee manhours thoroughly before submitting. Ensure the breaklist reflects the
                correct working hours, breaks, and overtime. Only confirm when all entries have been validated for
                accuracy.
              </Typography>
              <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                <CheckCircleOutlineIcon sx={{color: 'success.main', mr: 1}} />
                <Typography variant="body1">Confirm only if all time records are complete and correct.</Typography>
              </Box>
              <Box
                sx={{display: 'flex', alignItems: 'center', p: 1, backgroundColor: 'warning.lighter', borderRadius: 1}}
              >
                <WarningAmberIcon sx={{color: 'warning.main', mr: 1}} />
                <Typography variant="body2">
                  Once approved Manhours cannot be modified, records will be forwarded to Payroll for salary processing
                  and any errors must be corrected before approval.
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{mb: 1}}>
              An OTP has been sent to:{' '}
              <strong>
                {user.useAlternativeBreaklistEmail && user.alternativeBreaklistEmail
                  ? user.alternativeBreaklistEmail
                  : user.email}
              </strong>
            </Typography>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
              <TextField
                fullWidth
                margin="normal"
                label="Enter OTP"
                variant="outlined"
                type="text"
                inputProps={{maxLength: 6}}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <Button
                variant="outlined"
                onClick={handleResendOtp}
                disabled={otpCooldown > 0 || isSendingOtp}
                sx={{
                  minWidth: '120px',
                  textTransform: 'none',
                  ml: 1,
                  mt: 1,
                  height: '56px',
                }}
              >
                {isSendingOtp ? (
                  <CircularProgress size={20} />
                ) : otpCooldown > 0 ? (
                  `Resend OTP (${otpCooldown}s)`
                ) : (
                  'Resend OTP'
                )}
              </Button>
            </Box>

            <TextField
              fullWidth
              margin="normal"
              label="Approved By"
              variant="outlined"
              type="text"
              value={approvedBy}
              onChange={(e) => setApprovedBy(e.target.value)}
              helperText="Name of the person approving the breaklist"
            />

            <FormControlLabel
              control={
                <Checkbox checked={termsAgreed} onChange={(e) => setTermsAgreed(e.target.checked)} color="primary" />
              }
              label="I confirm that all employee manhours in this breaklist are accurate and ready for payroll."
              sx={{mt: 1, alignItems: 'flex-start'}}
            />
          </DialogContent>
          <DialogActions sx={{pb: 3, px: 3}}>
            <Stack spacing={2} sx={{width: '100%'}}>
              <Button
                size="large"
                variant="contained"
                onClick={handleConfirmApprove}
                disabled={!termsAgreed || !otp || !approvedBy || isApproving}
                sx={{
                  textTransform: 'initial !important',
                  backgroundColor: !(!termsAgreed || !otp || !approvedBy || isApproving) ? 'primary.main' : 'grey.400',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: !(!termsAgreed || !otp || !approvedBy || isApproving)
                      ? 'primary.dark'
                      : 'grey.400',
                  },
                }}
                startIcon={isApproving ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {isApproving ? 'Approving...' : 'Confirm Approve'}
              </Button>
              <Button
                onClick={() => {
                  setOpenApproveDialog(false)
                  setSelected([])
                  setOtp('')
                  setTermsAgreed(false)
                  setApprovedBy('')
                }}
                size="large"
                variant="outlined"
                color="error"
                disabled={isApproving}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
        {/*<Dialog open={openApproveDialog}>
          <Button sx={{ ml: 'auto', pt: 2 }} onClick={() => setOpenApproveDialog(false)}>
            <Icon icon={closeIcon} width={32} height={32} color="#b2b2b2" />
          </Button>
          <DialogTitle sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ maxWidth: '75%', mx: 'auto' }}>
              Are you sure you want to approve this breaklist?
            </Typography>
          </DialogTitle>
          <DialogActions sx={{ display: 'block', pb: 5, px: 3 }}>
            <Typography variant="h6" sx={{ mb: 6, fontWeight: 400, textAlign: 'center', mx: 'auto' }}>
              Once action processed you may not be able to retrieve the data.
            </Typography>
            <Stack sx={{ my: 2 }}>
              <Button
                color="primary"
                size="large"
                variant="contained"
                onClick={() => {
                  // setEdit(true)
                  setOpenApproveDialog(false)
                  handleConfirmApprove()
                }}
                disabled={false}
                sx={{ textTransform: 'initial !important' }}
              >
                Confirm Approve
              </Button>
              <Button
                // onClick={() => setEnableEdit(!isEnableEdit)}
                size="large"
                variant="outlined"
                color="error"
                sx={{ mt: 2 }}
              >
                Cancel
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>*/}
        <Dialog open={openQR} onClose={handleCloseQR}>
          <DialogTitle>
            Scan store QR code.
            <IconButton
              aria-label="close"
              onClick={handleCloseQR}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <>
              <QrReader
                delay={3000}
                onError={handleError}
                onScan={handleScan}
                // chooseDeviceId={()=>selected}
                style={{width: '250px', heigth: '200px'}}
                // className={'qrScanner'}
              />
              {/*<DialogTitle style={{ display: "flex", justifyContent: "center" }}><a href="https://www.sparkletimekeeping.com/store/create">Register store account</a></DialogTitle>*/}
            </>
          </DialogContent>
        </Dialog>
      </Container>
    </Page>
  )
}

